import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink, ShieldCheck } from "lucide-react";
import { SITE, COURSES } from "@/lib/site";

const COURSE = COURSES.find((c) => c.slug === "starting-a-tax-business");

export default function TaxSchoolApply() {
  const embedUrl = COURSE?.applicationEmbedUrl?.replace("/viewform?", "/viewform?embedded=true&");

  return (
    <div data-testid="tax-school-apply-page" className="bg-white">
      {/* Header band */}
      <section className="bg-[var(--trj-navy)] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full" style={{background:"radial-gradient(closest-side, rgba(212,175,55,0.25), transparent)"}}/>
        </div>
        <div className="relative max-w-5xl mx-auto px-6 py-16 md:py-20">
          <Link to="/tax-school" className="inline-flex items-center gap-2 text-[12px] text-white/70 hover:text-[var(--trj-gold)]" data-testid="apply-back-link">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to Tax School
          </Link>
          <div className="trj-eyebrow mt-5">Apply · Starting a Tax Business</div>
          <h1 className="font-serif-trj text-4xl md:text-5xl mt-3 leading-[1.05]">
            Application — Starting a Tax Business
          </h1>
          <p className="mt-5 text-white/75 max-w-2xl leading-relaxed">
            Tell us a bit about you and your goals. After you submit, our team will review your application
            and follow up with next steps within one business day.
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-4 text-[12px] text-white/65">
            <span className="inline-flex items-center gap-2"><ShieldCheck className="w-3.5 h-3.5 text-[var(--trj-gold)]" /> Secure form, encrypted in transit</span>
            <span>·</span>
            <a
              href={COURSE?.applicationEmbedUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 hover:text-white"
              data-testid="apply-open-in-google"
            >
              <ExternalLink className="w-3.5 h-3.5" /> Open in a new tab
            </a>
          </div>
        </div>
        <div className="gold-rule" />
      </section>

      {/* Embedded form */}
      <section className="bg-[var(--trj-light)] py-12 md:py-16" data-testid="apply-embed-section">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-white border border-gray-200 shadow-sm overflow-hidden">
            {embedUrl ? (
              <iframe
                src={embedUrl}
                title="Starting a Tax Business — Application Form"
                className="w-full"
                style={{ height: "1500px", border: "0" }}
                data-testid="apply-iframe"
                loading="lazy"
              >
                Loading…
              </iframe>
            ) : (
              <div className="p-10 text-center text-[var(--trj-muted)]">
                Application form is currently unavailable. Please contact us at {SITE.email}.
              </div>
            )}
          </div>
          <p className="text-center text-[11px] text-[var(--trj-muted)] mt-4">
            Trouble seeing the form? <a href={COURSE?.applicationEmbedUrl} target="_blank" rel="noopener noreferrer" className="text-[var(--trj-green)] hover:underline">Open it in a new tab</a>.
          </p>
        </div>
      </section>
    </div>
  );
}
